module.exports = _.constant;